import { ContentHeader } from "../../components";
import { Button, Input, Row, Col, Table, Tabs, Space } from 'antd';
import { DownloadOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { timKiemDSLopDaoTao, timKiemDSLopDaoTaoTheoKH } from '../../services/daotao';
import { TimKiemLopDaoTaoPagingResponse, LopDaoTao } from "../../models/daotao/LopDaoTao";
import { useEffect, useState } from "react";
import { searchLength, trangThaiLopDaoTao } from '../../constants';
import { Link } from 'react-router-dom';
import Column from 'antd/es/table/Column';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from "../../helpers/common";
import { toast } from "react-toastify";
import { xuatBaoCaoDaoTao } from "../../services/report";
import TrangThaiLopDaoTaoTag from "./TrangThaiLopDaoTaoTag";

const DanhSachLopDaoTao = () => {
    const [danhsach, setDanhSach] = useState<TimKiemLopDaoTaoPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const [danhsachTab2, setDanhSachTab2] = useState<TimKiemLopDaoTaoPagingResponse>({
        "data": [],
        "recordsTotal": 0,
        "maxPage": 0,
        "pageCurrent": 0,
        "pageListShow": [0]
    });
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);
    const [pageTab2, setPageTab2] = useState(1);
    const [tuKhoaTab2, setTuKhoaTab2] = useState<string>("");
    const [isLoadingTableTab2, setIsLoadingTableTab2] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<string>("1");
    const menu: any = menuHelper.checkMultiPermission([Links.NhanVien.ChiTiet]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [loading, setLoading] = useState(true);

    const timkiem = async (tuKhoa: string, start: number, length: number, page: number) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await timKiemDSLopDaoTao(tuKhoa, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSach({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTable(false);
        }
        catch (error: any) {
        };
    }

    const timkiemTab2 = async (tuKhoa: string, start: number, length: number, page: number) => {
        try {
            setPageTab2(1);
            setIsLoadingTableTab2(true);
            const temp = await timKiemDSLopDaoTaoTheoKH(tuKhoa, start, length);
            const maxPage = temp?.recordsTotal === 0 ? 0 : (parseInt((temp?.recordsTotal / searchLength).toString()) + (temp?.recordsTotal % searchLength ? 0 : -1)) || 0;
            setDanhSachTab2({
                "data": (temp?.data || []).map((item: any) => { item.key = item.id; return item }),
                "recordsTotal": temp?.recordsTotal || 0,
                "maxPage": maxPage,
                "pageCurrent": page,
                "pageListShow": []
            });
            setIsLoadingTableTab2(false);
        }
        catch (error: any) {
        };
    }

    const xuatBaoCao = async (tuKhoa: string) => {
        setIsLoadingTable(true);
        try {
            var response = await xuatBaoCaoDaoTao(tuKhoa);
            let link = document.createElement('a');

            link.download = `QuanLy_DanhSachLopDaoTao.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setIsLoadingTable(false);
        } catch (error: any) {
            setIsLoadingTable(false);
            toast.error(error || 'Có lỗi xảy ra');
        }
    }
    const xuatBaoCaoTab2 = async (tuKhoa: string) => {
        setIsLoadingTableTab2(true);
        try {
            var response = await xuatBaoCaoDaoTao(tuKhoa);
            let link = document.createElement('a');

            link.download = `QuanLy_DanhSachLopDaoTao.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            setIsLoadingTableTab2(false);
        } catch (error: any) {
            setIsLoadingTableTab2(false);
            toast.error(error || 'Có lỗi xảy ra');
        }
    }

    useEffect(() => {
        if (reloadPage) {
            setDanhSach({
                "data": [],
                "recordsTotal": 0,
                "maxPage": 0,
                "pageCurrent": 0,
                "pageListShow": [0]
            });
            timkiem(tuKhoa, 0, 0, 0);
            timkiemTab2(tuKhoa, 0, 0, 0);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(tuKhoa, 0, 0, 0)
        }
    };
    const handleKeyPressTab2 = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiemTab2(tuKhoaTab2, 0, 0, 0)
        }
    };
    return (<section>
        <ContentHeader title="Quản lý đào tạo" />
        {activeTab == "1" &&
            <Row className="form-group" gutter={8}>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên lớp, tên giảng viên, địa điểm tổ chức, đơn vị đào tạo" onChange={(e) => setTuKhoa(e.target.value)}
                        onKeyPress={handleKeyPress} />
                </Col>
                <Col span={8}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(tuKhoa, 0, 0, 0)}>
                            Tìm kiếm
                        </Button>
                        <Button className="hrm-btn hrm-btn-success" icon={<DownloadOutlined rev="" />} onClick={() => xuatBaoCao(tuKhoa)}>
                            Xuất excel
                        </Button>
                    </Space>
                </Col>
                <Col span={8}>
                    {
                        menu[Links.NhanVien.ChiTiet] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.DaoTao.ChiTiet} > <PlusOutlined rev="" />Thêm mới </Link>
                    }
                </Col>
            </Row>
        }
        {activeTab == "2" &&
            <Row className="form-group" gutter={8}>
                <Col span={8}>
                    <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên lớp, tên giảng viên, địa điểm tổ chức, đơn vị đào tạo" onChange={(e) => setTuKhoaTab2(e.target.value)}
                        onKeyPress={handleKeyPressTab2} />
                </Col>
                <Col span={8}>
                    <Space>
                        <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiemTab2(tuKhoaTab2, 0, 0, 0)}>
                            Tìm kiếm
                        </Button>
                        <Button className="hrm-btn hrm-btn-success" icon={<DownloadOutlined rev="" />} onClick={() => xuatBaoCaoTab2(tuKhoa)}>
                            Xuất excel
                        </Button>
                    </Space>
                </Col>
                <Col span={8}>
                    {
                        menu[Links.NhanVien.ChiTiet] &&
                        <Link className="hrm-btn float-right hrm-btn-warning" to={Links.DaoTao.ChiTiet} > <PlusOutlined rev="" />Thêm mới </Link>
                    }
                </Col>
            </Row>
        }
        <Tabs activeKey={activeTab} onChange={(e) => { setActiveTab(e) }}
            items={[{
                key: '1',
                label: 'Lớp đã đào tạo',
                children: <Row gutter={8}>
                    <Col span={24}>
                        <div className="card card-primary">
                            <Row>
                                <Col span={24}>
                                    <Table
                                        loading={isLoadingTable}
                                        locale={{ emptyText: "Không có dữ liệu" }}
                                        dataSource={danhsach?.data}
                                        pagination={{
                                            current: page,
                                            onChange: (page, pageSize) => {
                                                setPage(page);
                                            },
                                        }}>
                                        <Column
                                            title="STT"
                                            key="STT" align="center"
                                            render={(value, record, index) =>
                                            (
                                                <span key={"stt" + index}>
                                                    {(page - 1) * searchLength + index + 1}
                                                </span>
                                            )
                                            }
                                        />
                                        <Column title="Người theo dõi" dataIndex="hoTenNVTheoDoi" key="hoTenNVTheoDoi" />
                                        <Column title="Tên lớp" dataIndex="ten" key="ten" />
                                        <Column
                                            title="Thời gian"
                                            key="ngayBatDau"
                                            width={"210px"}
                                            render={(value, record, index) =>
                                            (<span key={"ngayBatDau" + index}>
                                                {dateCommon.formatDate(value?.ngayBatDau)} - {dateCommon.formatDate(value?.ngayKetThuc)}
                                            </span>
                                            )

                                            }
                                        />
                                        <Column title="Giảng viên" dataIndex="giangVien" key="giangVien" />
                                        <Column title="Đơn vị đào tạo" dataIndex="donViDaoTao" key="donViDaoTao" />
                                        <Column title="Hình thức tổ chức" dataIndex="tenHinhThucToChuc" key="tenHinhThucToChuc" />
                                        <Column align="center" title="SL Nhân viên" dataIndex="soLuongNhanVien" key="soLuongNhanVien" />
                                        <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                            return <TrangThaiLopDaoTaoTag value={value} />
                                        }} />
                                        <Column
                                            title=""
                                            key="action"
                                            render={(value, record, index) =>
                                            (
                                                <div className="action">
                                                    <Link key={"xem" + index} className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.DaoTao.Xem}?id=${value?.id}`}>Xem</Link>
                                                </div>
                                            )
                                            }
                                        />
                                    </Table>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            }, {
                    key: '2',
                    label: 'Lớp theo kế hoạch',
                    children: <Row gutter={8}>
                        <Col span={24}>
                            <div className="card card-primary">
                                <Row>
                                    <Col span={24}>
                                        <Table
                                            loading={isLoadingTableTab2}
                                            locale={{ emptyText: "Không có dữ liệu" }}
                                            dataSource={danhsachTab2?.data}
                                            pagination={{
                                                current: pageTab2,
                                                onChange: (page, pageSize) => {
                                                    setPageTab2(page);
                                                },
                                            }}>
                                            <Column
                                                title="STT"
                                                key="STT" align="center"
                                                render={(value, record, index) =>
                                                (
                                                    <span key={"stt" + index}>
                                                        {(page - 1) * searchLength + index + 1}
                                                    </span>
                                                )
                                                }
                                            />
                                            <Column title="Người theo dõi" dataIndex="hoTenNVTheoDoi" key="hoTenNVTheoDoi" />
                                            <Column title="Tên lớp" dataIndex="ten" key="ten" />
                                            <Column
                                                title="Thời gian"
                                                key="ngayBatDau"
                                                width={"210px"}
                                                render={(value, record, index) =>
                                                (<span key={"ngayBatDau" + index}>
                                                    {dateCommon.formatDate(value?.ngayBatDau)} - {dateCommon.formatDate(value?.ngayKetThuc)}
                                                </span>
                                                )

                                                }
                                            />
                                            <Column title="Giảng viên" dataIndex="giangVien" key="giangVien" />
                                            <Column title="Đơn vị đào tạo" dataIndex="donViDaoTao" key="donViDaoTao" />
                                            <Column title="Hình thức tổ chức" dataIndex="tenHinhThucToChuc" key="tenHinhThucToChuc" />
                                            <Column align="center" title="SL Nhân viên" dataIndex="soLuongNhanVien" key="soLuongNhanVien" />
                                            <Column title="Trạng thái" dataIndex="trangThai" key="trangThai" align="center" render={(value, record) => {
                                                return <TrangThaiLopDaoTaoTag value={record.trangThai} />
                                            }} />
                                            <Column
                                                title=""
                                                key="action"
                                                render={(value, record, index) =>
                                                (
                                                    <div className="action">
                                                        {record.trangThai >= trangThaiLopDaoTao.khoiTao &&
                                                            <Link
                                                                key={"xem" + index}
                                                                className="hrm-btn hrm-btn-sm btn-primary"
                                                                to={`${Links.DaoTao.Xem}?id=${record.id}`}
                                                            >
                                                                Xem
                                                            </Link>
                                                        }
                                                    </div>
                                                )
                                                }
                                            />
                                        </Table>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                }]} />

    </section>
    );
}
export default DanhSachLopDaoTao;